import * as navigation from 'Navigation';

export default class EmbeddedAnalyticsDashboardTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Dashboard',
      closeable: false,
      preferenceKey: 'embedded-analytics-dashboard',
    };
  }
}
